import { Link } from "react-router-dom";
import { Scissors } from "lucide-react";

export default function Navbar({ onBookNow }) {
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 border-b border-stone-800/80 bg-stone-950/70 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand"
          className="flex items-center gap-2 group"
        >
          <Scissors
            size={18}
            className="text-amber-500 group-hover:rotate-45 transition-transform duration-500"
          />
          <span className="font-display text-lg tracking-tight text-stone-50">
            Andooozy<span className="text-amber-500">Cutzz</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-stone-400">
          <a
            href="#about"
            data-testid="nav-link-about"
            className="hover-sweep hover:text-stone-50 transition-colors duration-300"
          >
            About
          </a>
          <a
            href="#services"
            data-testid="nav-link-services"
            className="hover-sweep hover:text-stone-50 transition-colors duration-300"
          >
            Services
          </a>
          <a
            href="#contact"
            data-testid="nav-link-contact"
            className="hover-sweep hover:text-stone-50 transition-colors duration-300"
          >
            Contact
          </a>
          <Link
            to="/admin"
            data-testid="nav-link-admin"
            className="hover-sweep hover:text-stone-50 transition-colors duration-300"
          >
            Admin
          </Link>
        </nav>

        <button
          data-testid="nav-book-btn"
          onClick={onBookNow}
          className="bg-amber-500 text-stone-950 px-5 py-2 text-sm font-medium tracking-wide hover:bg-amber-400 transition-colors duration-300"
        >
          Book Now
        </button>
      </div>
    </header>
  );
}
